"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @file fetch wall layouts
var api_fetch_1 = require("./api_fetch");
/**
 * Fetch a WallLayoutSections object defined in WallLayouts.rb#wall_layout_sections.
 *
 * @returns A Promise that resolves to a JsonAPIResponse<WallLayoutSections>.
 *
 */
function fetchWallLayouts() {
  return (0, api_fetch_1.apiFetch)('wall_layouts');
}
exports.default = fetchWallLayouts;